import api from '../api'

export default {
    namespaced: true,
    state: {
        etList: []
    },
    mutations: {
        setStateETList(state, info) {
            state.etList = info
        }
    },
    getters: {
        etTimeOptions(state) {
            return state.etList.map(item => {
                return {
                    label: `${item.startTime} - ${item.endTime}`,
                    value: `${item.startTime} - ${item.endTime}`,
                }
            })
        },
        etStartTimeArr(state) {
            return state.etList.map(item => {
                return +item.startTime.split(':')[0]
            })
        }
    },
    actions: {
        getATClubList() {
            return api.post('/at/club/list', 'AT俱乐部列表')
        },
        getATList(store, clubId) {
            return api.post(`/at/club/${clubId}/atlist`, '指定俱乐部的AT用户列表')
        },
        addAT(store, {clubId, ...params}) {
            return api.post(`/at/club/${clubId}/atadd`, '新增AT用户', params)
        },
        updateAT(store, params) {
            return api.post(`/at/club/atuser/${params.userId}`, '修改AT用户', params)
        },
        getMTList(store, clubId) {
            return api.post(`/at/club/${clubId}/mtlist`, '指定俱乐部的MT用户列表')
        },
        addMT(store, {clubId, ...params}) {
            return api.post(`/at/club/${clubId}/mtadd`, '新增MT用户', params)
        },
        getATDetail() {
            return api.post('/at/switch/detail', 'AT分发开关配置')
        },
        atApply(store, params) {
            return api.post('/at/apply', '下发AT玩家配置到牌局服务', params)
        },
        atSwitchApply(store, params) {
            return api.post('/at/switch/apply', '下发模式开关配置到牌局服务', params)
        },
        mtDispatch(store, params) {
            return api.post('/at/mt/dispatch', '派发MT用户到牌局服务', params)
        },
        getETDetail({commit},roomPath) {
            return api.post(`/at/et/detail/${roomPath}`, '获取当前ET时间区间配置').then(res => {
                commit('setStateETList', res.data)
            })
        },
        updateET(store, params) {
            return api.post(`/at/et/apply/${params.roomPath}`, '保存并下发配置到牌局服务', params.etList)
        }
    }
}